import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import
{
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import DataList from './dataList';
import UserListDialog from './userListDialog';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const Resource = (props) =>
{
    const showSearch = true;
    const history = useHistory();
    const authState = useAuthState();
    const eventState = useEventState();
    const loading = useState(true);
    const allData = useState([]);
    const allListData = useState();
    const eventData = useState(null);
    const userID = useState(null);
    const requestPending = useState(null);
    const currentResource = useState({});
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const openAddParticipantDialog = useState(false);
    const userInfo = useState({});

    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const filteredEmty = useState(false);
    const filteredList = useState([]);
    const isView = useState(false);
    // const originalData = useState([]);
    // const userId = useState(0);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [resourceData, setResourceData] = React.useState(null)
    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfos = Helper.getStorage('userInfo');
        userInfo.set(userInfos);
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        )
        {
            eventData.set(eventInfo);
            userID.set(userInfos.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        )
        {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() =>
    {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get())
        {
            if (Helper.isAdminUser(userInfo) || userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                setModPermission(FULL_PERMISSION);
            } 
            // else if (userInfo.roles && Helper.isEventAdmin(userInfo))
            // {
            //     const permissions = eventState.permissions
            //         .attach(Downgraded)
            //         .get();
            //         console.log("permissions",permissions);
            //     if (permissions && permissions.length > 0)
            //     {
            //         setModPermission(
            //             Helper.getModuleAccessPermission(permissions, 'HOTEL')
            //         );
            //     }
            // }
        }
        console.log("modPermission",modPermission);
    }, [eventState]);

    useEffect(() =>
    {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION)
        {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage)
            {
                getAdminResoureList();
            }
        }
    }, [modPermission]);
    useEffect(() =>
    {
        const eventInfo = Helper.getStorage('eventInfo');

        ApiHelper.get(APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID))
            .then(res =>
            {
                let participantData = [];
                res.data.rows.map((item) =>
                {
                    participantData.push({ ...item, selected: false })

                })
                overallParticipants.set(participantData);
                // let userId = 0;
                // fetchActivities(userId);

            })
    }, [])
    const getAdminResoureList = () =>
    {
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_RESOURCE(eventData.get().eventID))
            .then((res) =>
            {
                if (res.data)
                {
                    let data = res.data.resources;
                    let requestData = [];
                    if (data.length > 0)
                    {
                        data.map((item) =>
                        {

                            requestData.push({
                                actualData: item,
                                row: [

                                    {
                                        label: 'Access',
                                        key: 'access',
                                        access: item.isPublic,
                                        width: '0.05',
                                        showLabel: false,
                                        alignLeft: true,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'participant',
                                        key: 'participant',
                                        participant: item.resourceName,
                                        width: '0.55',
                                        showLabel: false,
                                        alignLeft: true,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'All',
                                        count: item.participants.length,
                                        all: 'All',
                                        width: '0.40',
                                        inColumn: true,
                                        alignCenter: false,
                                    },
                                ],
                                selected: false,
                            });
                        });
                    } else
                    {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                    }
                    setShowSearchRec(false);
                    allData.set(requestData);
                    allListData.set(requestData);
                    loading.set(false);
                    if (pagingInfo.get().noOfPages == null)
                    {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
    }
    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
    };
    const handleAddParticipants = (resource) =>
    {
        currentResource.set(resource)
        ApiHelper.get(APIURLConstants.GET_RESOURCE_PARTICIPANTS(resource.actualData.eventResourceID))
            .then(participants =>
            {
                let ids = participants.data.map(x => x.userID);
                let allParticipants = overallParticipants.attach(Downgraded).get()
                let userList = allParticipants.filter(x => !ids.includes(x.userID) && x.roleName!=="Event Staff")
                filteredParticipants.set(userList)
                openAddParticipantDialog.set(true);
            }).catch(err =>
            {
                console.log(err);
                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
            })
    }
    const handleViewParticipants = (resource) =>
    {
        currentResource.set(resource)
        isView.set(true)
        ApiHelper.get(APIURLConstants.GET_RESOURCE_PARTICIPANTS(resource.actualData.eventResourceID))
            .then(participants =>
            {
                let ids = participants.data.map(x => x.userID);
                let allParticipants = overallParticipants.attach(Downgraded).get()
                let userList = allParticipants.filter(x => ids.includes(x.userID))
                filteredParticipants.set(userList)
                openAddParticipantDialog.set(true);
            })
            .catch(err =>
            {
                console.log(err);
                setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
            });

    }
    const handleResourceDelete = (resource) =>
    {
        let message = 'Do you want to delete documents?'
        deleteConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
        setResourceData(resource)

    }
    const handleConfirmation = () =>
    {

        let obj = { EventResourceID: resourceData.actualData.eventResourceID }
        if (resourceData.actualData.eventResourceID)
        {

            ApiHelper.post(APIURLConstants.DELETE_RESOURCE, obj)
                .then(result =>
                {
                    if (result.data)
                    {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Documents deleted successfully.' });
                        isView.set(false);
                        getAdminResoureList();
                    } else
                    {
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }
                    setResourceData(null);
                    deleteConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                })
                .catch(err =>
                {
                    console.log(err);

                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    setResourceData(null)
                    deleteConfirmation.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                });
        }
    }
    const saveAppNotificationData = (selectedUsers, resourceID) =>
    {
        const AppNotificationData = {
            userIDs: selectedUsers.toString(),
            appNotificationTypeID: 2,
            eventID: eventData.get().eventID,
            moduleID: 11,
            recordRefID: resourceID,
            requestStatus: 2,
            status: 0,
            createdBy: userInfo.attach(Downgraded).get().userID
        }
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, AppNotificationData)
            .then(res =>
            {
                console.log("res1", res);
                // ApiHelper.get(
                //     APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                //         obj.item.addedFor,
                //         eventData.get().eventID,
                //         eventData.get().eventName,
                //         "Resources",
                //         obj.status === 2 ? "Approved" : obj.status === 3 ?"Rejected" : "Pending"
                //     )
                // ).then((res) =>
                // {
                //     console.log(res);
                // });
            })
            .catch(err =>
            {
                console.log("err", err);
            });
    }
    const addParticipants = (selectedUsers) =>
    {
        if (selectedUsers.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else
        {
            let resource = currentResource.attach(Downgraded).get();
            let obj = { EventResourceID: resource.actualData.eventResourceID, createdBy: userInfo.attach(Downgraded).get().userID, participants: selectedUsers }

            return ApiHelper.post(APIURLConstants.POST_RESOURCE_PARTICIPANTS, obj)
                .then(res =>
                {
                    if (res)
                    {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Participants added successfully.' });
                        // fetchActivities(userId.get());
                        console.log(selectedUsers, resource.actualData.eventResourceID)
                        let filteredIds=overallParticipants
                        .attach(Downgraded)
                        .get().filter((elem) =>elem.isPublished===true && elem.userID==selectedUsers.toString()
                            ).map((x)=>x.userID)
                        if (eventData.get().readonlyOrHide === 0 && filteredIds.length>0)
                        {
                            saveAppNotificationData(filteredIds, resource.actualData.eventResourceID);
                        }
                        openAddParticipantDialog.set(false);
                        getAdminResoureList();
                    } else
                    {
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }
                })
                .catch(err =>
                {
                    console.log(err);
                });
        }
    }
    const deleteNotificationParticiapant = (userIDs, resourceID, modifiedByID) =>
    {
        const delObj = {
            usersIDs: userIDs.toString(),
            recordRefID: resourceID,
            moduleID: 11,
            eventID: eventData.get().eventID,
            modifiedBy: modifiedByID
        }
        ApiHelper.post(APIURLConstants.DELETE_NON_MODULE_APP_NOTIFICATIONS, delObj)
            .then(result =>
            {
                console.log("result", result);
            })
    }
    const deleteParticipants = (selectedUsers) =>
    {
        if (selectedUsers.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else
        {
            let resource = currentResource.attach(Downgraded).get();
            let obj = { EventID: eventData.get().eventID, EventResourceID: resource.actualData.eventResourceID, modifiedBy: userInfo.attach(Downgraded).get().userID, Ids: selectedUsers }
            // ScheduleDataService.deleteActivityParticipants(obj)
            ApiHelper.post(APIURLConstants.DELETE_RESOURCE_PARTICIPANTS, obj)
                .then(result =>
                {
                    if (result.data)
                    {
                        setSnackBarProps({ openSnack: true, variant: 'success', message: 'Participants deleted successfully.' });
                        // fetchActivities(userId.get());
                        deleteNotificationParticiapant(selectedUsers, resource.actualData.eventResourceID, userInfo.attach(Downgraded).get().userID)
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                        getAdminResoureList();
                    } else
                    {
                        setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                    }
                })
                .catch(err =>
                {
                    console.log(err);
                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                });

        }
    }
    const handleCloseAddParticipant = () =>
    {
        openAddParticipantDialog.set(false);
        isView.set(false);
    }
    // const fetchActivities = async (userId) =>
    // {
    //     let result = await ScheduleDataService.getActivityList(eventData.get().eventID, userId);
    //     originalData.set(result.data);
    // }



    const redirectToEdit = (data) =>
    {
        const row = data.actualData;
        // let registeredIds = allData.attach(Downgraded).get().map(x => x.actualData.addedFor)
        // let index = registeredIds.indexOf(row.addedFor)
        // registeredIds.splice(index, 1);
        // let filteredParticipants = participantList.filter(x => !registeredIds.includes(x.userID))
        // console.log(eventData.get().eventID, row.eventResourceID);
        const path = generatePath(RouteConstants.EDIT_EVENT_RESOURCE, {
            eventID: eventData.get().eventID,
            eventResourceID: row.eventResourceID,
        });
        // , participantList: filteredParticipants
        history.push({
            pathname: path,
            state: { resourceState: row },
        });
    };

    const onAddRequest = () =>
    {

        // let registeredIds = allData.attach(Downgraded).get().map(x => x.actualData.addedFor)
        // let filteredParticipants = participantList.filter(x => !registeredIds.includes(x.userID))
        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_EVENT_RESOURCE, {
                eventID: eventData.get().eventID,
            }),
            state: {},
        });
    };
    const filterListData = (data) =>
    {
        if (data.length == 0)
        {
            filteredEmty.set(true)
        } else
        {
            filteredEmty.set(false)
        }
        filteredList.set(data);
    }
    const onDelete = () =>
    {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const onPendingAction = (item) =>
    {
        let newData = [...allData.attach(Downgraded).get()];
        let index = newData.findIndex(
            (data) => data.actualData.hotelBookID == item.actualData.hotelBookID
        );
        let newItem = newData[index].actualData;

        const isStatus = 1;

        requestPending.set({
            status: isStatus,
            userID: userID.get(),
            hotelBookID: newItem.hotelBookID,
        });

        let message = 'Do you want to move request to pending?';

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    };

    const handleDownload = (link) =>
    {
        const splitUrl = link.split(',');
        splitUrl.map((val) =>
        {
            window.open(val);
        });
    }

    return (
        <Box sx={{ width: '100%' }} className="contentBox">
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <DataList
                    participants={overallParticipants.attach(Downgraded).get()}
                    data={allData.attach(Downgraded).get()}
                    editRow={redirectToEdit}
                    handleClick={onAddRequest}
                    title={''}
                    buttonTitle={'Add'}
                    deleteRows={onDelete}
                    showSearch={showSearch}
                    searchLabel={'Search'}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    handleAddParticipants={handleAddParticipants}
                    handleViewParticipants={handleViewParticipants}
                    handleResourceDeletes={handleResourceDelete}
                    hideApproveReject={true}
                    pagingInfo={pagingInfo.attach(Downgraded).get()}
                    handlePageChange={handlePageChange}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    onPendingAction={onPendingAction}
                    modPermission={modPermission}
                    filterListData={filterListData}
                    moduleToShow={"Manage Event Documents"}
                    hideDelete={true}
                    handleDownload={handleDownload}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {openAddParticipantDialog.get() && (
                <UserListDialog
                    title={!isView.get() ? "ADD PARTICIPANTS" : "VIEW PARTICIPANTS"}
                    addParticipants={addParticipants}
                    open={openAddParticipantDialog.get()}
                    deleteParticipants={deleteParticipants}
                    handleClose={handleCloseAddParticipant}
                    users={filteredParticipants.attach(Downgraded).get()}
                    isView={isView.get()}
                    selectAllCheckBox={true}
                />
            )}
        </Box>

    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_RESOURCE,
        component: Resource,
    },
    name: 'Resource',
};
